import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { SvgIconModule } from '../../components/svg-icon';
import { UploadMediaModule } from '../../components/upload-media/upload-media.module';
import { UploadCropperModule } from '../../components/upload-cropper/upload-cropper.module';
import { CodeEditorModule } from '../code-editor/code-editor.module';

import { MediumEditorComponent } from './medium-editor.component';
import { BlogEditorComponent } from './blog-editor.component';
import { CmsEditorModule } from '../cms-editor/cms-editor.module';

@NgModule({
    declarations: [
        BlogEditorComponent,
        MediumEditorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        SvgIconModule,
        UploadMediaModule,
        UploadCropperModule,
        CodeEditorModule,
        CmsEditorModule
    ],
    exports: [
        BlogEditorComponent
    ]
})
export class BlogEditorModule { }
